<template>
  <el-dialog title="信息发布" :visible.sync="show" width="748px" class="loginWrapper" @close="$emit('cancel')">
    <el-form :model="form" :rules="rules" ref="publishForm">
      <el-form-item label="主题" prop="theme">
        <el-input v-model="form.theme" class="input" placeholder="请输入主题名称"></el-input>
      </el-form-item>
      <el-form-item label="课程优势" prop="advantage">
        <el-input v-model="form.advantage" class="input" placeholder="请简要说明课程优势"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="telephone">
        <el-input v-model="form.telephone" class="input" maxlength="20" placeholder="请输入您的联系方式"></el-input>
      </el-form-item>
      <div class="inline">
        <el-form-item label="上课方式" prop="lessonMethod">
          <el-radio-group v-model="form.lessonMethod">
            <el-radio :label="1">户外面授</el-radio>
            <el-radio :label="2">室内面授</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="价格" prop="priceMethod" style="margin-left:100px;">
          <el-radio-group v-model="form.priceMethod">
            <el-radio :label="1">固定价格&nbsp;&nbsp;<el-input v-model="form.price" :disabled="form.priceMethod !== 1" class="priceInp" placeholder="如：1000"></el-input>&nbsp;&nbsp;元</el-radio>
            <el-radio :label="2">询价</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item label="课程详情" prop="lessonDetail">
        <div class="wangEditor" @click="handleClick">
          <Toolbar
            style="border: 1px solid #eee;"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
          />
          <Editor
            class="editor"
            v-model="form.lessonDetail"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
            @onChange="onChange"
          />
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" class="publishBtn" @click="submitForm('publishForm')">发布</el-button>
      <el-button class="resetBtn" @click="resetForm('publishForm')">全部重置</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  name: 'publish',
  components: { Editor, Toolbar },
  props: {
    publishVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        readOnly: false,
        autoFocus: true,
        placeholder: '请图文介绍描述此课程的具体信息...',
        MENU_CONF: {
          uploadImage: {
            // 后端上传地址，必填
            server: '/dev-api/common/upload',
            timeout: 5 * 1000, // 5s 超时时间
            fieldName: 'custom-fileName',
            // 选择文件时的类型限制，默认为['image/*'] 如不想限制，则设置为 []
            allowedFileTypes: ['image/*'],
            metaWithUrl: true, // 参数拼接到 url 上
            maxFileSize: 100 * 1024 * 1024, // 1g // 设置大点 不然图片过大会报错
            base64LimitSize: 100000 * 1024 // 1g 以下插入 base64
          },
          uploadVideo: {
            // form-data fieldName ，默认值 'wangeditor-uploaded-video'
            fieldName: 'your-custom-name',
            // 单个文件的最大体积限制，默认为 10M
            maxFileSize: 5 * 1024 * 1024, // 5M
            // 最多可上传几个文件，默认为 5
            maxNumberOfFiles: 3,
            // 选择文件时的类型限制，默认为 ['video/*'] 。如不想限制，则设置为 []
            allowedFileTypes: ['video/*']
          }
        }
      },
      mode: 'default',
      show: false,
      form: {
        theme: '',
        advantage: '',
        telephone: '',
        lessonMethod: 1,
        priceMethod: 2,
        price: '',
        lessonDetail: '<p>hello</p>'
      },
      rules: {
        theme: [
          { required: true, message: '请输入主题', trigger: 'blur' }
        ],
        advantage: [
          { required: true, message: '请输入课程优势', trigger: 'change' }
        ],
        telephone: [
          { required: true, message: '请输入联系方式', trigger: 'change' }
        ],
        lessonMethod: [
          { required: true, message: '请输入上课方式', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'change' }
        ],
        lessonDetail: [
          { required: true, message: '请输入课程详情', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    publishVisible: {
      handler (nval) {
        this.show = nval
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy () {
    // const editor = this.editor
    if (this.editor == null) return
    this.editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    // 解决编辑器失去焦点后，重新获取焦点的问题
    handleClick () {
      this.editor.restoreSelection()
    },
    onCreated (editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onChange (editor) {
      console.log('onChange ????')
      console.log(editor)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (sessionStorage.getItem('TOKEN')) {
            this.$emit('confirm')
            this.$parent.infoVisible = true
          } else {
            this.$parent.loginVisible = true
          }
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.form.price = ''
      this.form.lessonDetail = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .loginWrapper{
    height: 100%;
    width: 100%;
    .input{
      width: 700px;
    }
    .priceInp{
      width: 120px;
    }
    .inline{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
    }
    .el-form-item{
      margin-bottom: 12px;
    }
    .wangEditor{
      width: 100%;
      min-height: 700px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border: 1px solid #eee;
      margin-bottom: 20px;
      .toobar{
        border: 1px solid #eee;
      }
      .editor{
        min-height: 500px;
        overflow-y: hidden;
        text-indent: 20px;
        text-align: left
      }
    }
    .forgetPass{
      float: left;
      margin: -10px 0 0 50px;
    }
    .dialog-footer{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .publishBtn{
        width: 150px;
        background-color: #BC1A33;
        border-color: #BC1A33;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
      .resetBtn{
        width: 150px;
        color: #BC1A33;
        border-color: #BC1A33;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
</style>
